module.exports = __webpack_public_path__ + "img/015.d7ad3781.jpg";